// extracted by mini-css-extract-plugin
export default {"container":"aB-z","dimension":"bB-z","dimensionLabels":"cB-z"};